import { combineReducers } from 'redux';
import users from 'views/Setup/Users/flow/reducer';
import companyInfo from 'views/Setup/CompanyInfo/flow/reducer';
import orgChart from 'views/Setup/OrganisationChart/flow/reducer';
import emailCampaign from 'views/email/emailCampaign/flow/reducer';
import emailTemplates from 'views/email/flow/reducer';
import permissionPro from 'views/Setup/PermissionProfile/flow/reducer';
import fields from 'views/Setup/Fields/flow/reducer/index';
import layouts from 'views/Setup/PageLayout/flow/reducerIndex';
import ipLists from 'views/Setup/IpWhiteLists/flow/reducer';
import searchLayout from 'views/Setup/SearchLayout/flow/reducer';
import generalSettings from 'views/Setup/GeneralSettings/flow/reducer';
import fileImport from 'views/Setup/ObjectImport/flow/reducer';
import fileExport from 'views/Setup/ObjectExport/flow/reducer';
import workFlow from 'views/Setup/WorkFlow/flow/reducer';
import apiToken from 'views/Setup/ApiToken/flow/reducer'

export default combineReducers({
  users,
  companyInfo,
  orgChart,
  emailTemplates,
  emailCampaign,
  permissionPro,
  fields,
  layouts,
  ipLists,
  searchLayout,
  generalSettings,
  fileImport,
  fileExport,
  workFlow,
  apiToken
});




// WEBPACK FOOTER //
// ./src/store/setupReducer.js